<template>
  <div>
    <b-img
      :src="appLogoImage"
      :alt="appName"
      class="app-logo"
    />
  </div>
</template>

<script>
import { BImg } from "bootstrap-vue"
import { $themeConfig } from "@themeConfig"

export default {
  components: {
    BImg,
  },
  setup() {
    const { appName, appLogoImage } = $themeConfig.app

    return { appName, appLogoImage }
  },
}
</script>

<style lang="scss" scoped>
.app-logo {
    height: 80px;
    width: auto;
    max-width: 100%;
}
</style>
